import { useEffect, useState } from "react";

import { getData, onlyUniqueValuesInObject } from "../../../../../services";
import { UnpaidElectricityBills } from "../../../../../components/parts";

export const Unpaid = ({ buildingId, complexId }) => {
  const [unpaidElectricityBills, setUnpaidElectricityBills] = useState();

  let url = `/praas/v2/buildings/properties/unpaid-electricity/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/unpaid/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/unpaid/`;
  }

  useEffect(() => {
    getData(url, (data) => {
      if (!onlyUniqueValuesInObject(data, null)) {
        setUnpaidElectricityBills([
          { value: data.price_sum },
          {
            value: data.tenant_count,
            description: `${
              data.over_three_month_debt || 0
            } of them have a long-term debts (over 3 months)`,
          },
        ]);
      }
    });
  }, [complexId, buildingId]);

  return <UnpaidElectricityBills data={unpaidElectricityBills} />;
};
